export default __webpack_public_path__ + "static/media/mobileHero.615cd48c.png";